/**
 * Build a success notification payload.
 *
 * @param {string} summary - Notification title.
 * @param {string} message - Notification message.
 * @returns {{
 *   severity: string, // Notification severity (`NOTIFICATION_SEVERITY.SUCCESS`).
 *   summary: string, // Notification title.
 *   detail: string // Notification message.
 * }}
 */
export function successNotification(summary, message) {
  return {
    severity: NOTIFICATION_SEVERITY.SUCCESS,
    summary: summary,
    detail: message
  }
}

/**
 * Build an error notification payload.
 *
 * @param {string} summary - Notification title.
 * @param {string} message - Notification message.
 * @returns {{
 *   severity: string, // Notification severity (`NOTIFICATION_SEVERITY.ERROR`).
 *   summary: string, // Notification title.
 *   detail: string, // Notification message.
 *   life: number // Display duration in milliseconds.
 * }}
 */
export function errorNotification(summary, message) {
  return {
    severity: NOTIFICATION_SEVERITY.ERROR,
    summary: summary,
    detail: message,
    life: 5000
  }
}

/**
 * Build a warning notification payload.
 *
 * @param {string} summary - Notification title.
 * @param {string} message - Notification message.
 * @returns {{
 *   severity: string, // Notification severity (`NOTIFICATION_SEVERITY.WARNING`).
 *   summary: string, // Notification title.
 *   detail: string, // Notification message.
 *   life: number // Display duration in milliseconds.
 * }}
 */
export function warningNotification(summary, message) {
  return {
    severity: NOTIFICATION_SEVERITY.WARNING,
    summary: summary,
    detail: message,
    life: 5000
  }
}

export const NOTIFICATION_SEVERITY = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warn',
  INFO: 'info'
}
